module.exports = __webpack_public_path__ + "static/media/opening-title.253f5fa1.webm";


//////////////////
// WEBPACK FOOTER
// ./src/Videos/opening-title.webm
// module id = 56
// module chunks = 0